import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-review-created",
  "use": "foquz-icon-review-created-usage",
  "viewBox": "0 0 15 10",
  "content": "<symbol viewBox=\"0 0 15 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-review-created\"><path stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M6 9h8M1 9h1m4-4h8M1 5h1m4-4h8M1 1h1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol